// src/components/customers/CustomerCreationModal.jsx
import React, { useState, useEffect } from 'react';
import { useCustomers } from '../../hooks/useCustomers';
import CustomerFormShadcn from '../ui/forms/CustomerForm/CustomerFormShadcn';
import { useToast } from '../../hooks/use-toast';

const CustomerCreationModal = ({
  isOpen,
  onClose,
  onSuccess
}) => {
  const { createCustomer, error, isConnected } = useCustomers();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const { toast } = useToast();
  
  // Clear states when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setSubmitError(null);
      setIsSubmitting(false);
    }
  }, [isOpen]);
  
  // Handle customer creation
  const handleCreateCustomer = async (customerData) => {
    if (!isConnected) {
      setSubmitError('Not connected to server. Please check your connection.');
      return;
    }
    
    try {
      setIsSubmitting(true);
      setSubmitError(null);
      
      console.log('🆕 Creating customer with data:', customerData);
      
      // Call the createCustomer method from useCustomers hook
      // This will emit the WebSocket event and handle real-time updates
      createCustomer(customerData);

      // Show success toast
      toast({
        title: "Success!",
        description: `Customer "${customerData.name}" created successfully!`,
      });

      // Close modal immediately and call success callback
      if (onSuccess) {
        onSuccess(customerData);
      }
      onClose();
      
    } catch (err) {
      console.error('❌ Customer creation error:', err);
      setSubmitError(err.message || 'Failed to create customer. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  // Handle modal close
  const handleClose = () => {
    if (!isSubmitting) {
      setSubmitError(null);
      onClose();
    }
  };
  
  // Determine which error to show (form error takes precedence)
  const displayError = submitError || error;
  
  return (
    <CustomerFormShadcn
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={handleCreateCustomer}
      loading={isSubmitting}
      error={displayError}
    />
  );
};

export default CustomerCreationModal;